import React, { useCallback, useEffect, useState } from 'react'
import * as ReactDOMServer from 'react-dom/server'

import MinusIcon from '@components/icons/Minus'
import PlusIcon from '@components/icons/Plus'

const minus = ReactDOMServer.renderToString(React.createElement(MinusIcon))
const plus = ReactDOMServer.renderToString(React.createElement(PlusIcon))

interface Args {
    identifier: string
    isValidating: boolean
}

const ACCORDION_ITEM_SELECTOR = '.casaideas-accordion-item'
const ACCORDION_ITEM_TITLE_SELECTOR = '.casaideas-accordion-title'
const ACCORDION_ITEM_CONTENT_SELECTOR = '.casaideas-accordion-content'

const useAccordion = ({ isValidating, identifier }: Args): void => {
    const [openItemId, setOpenId] = useState('')

    const onAccordionTitleClick = useCallback(
        (itemId = '') => {
            setOpenId(itemId === openItemId ? '' : itemId)
        },
        [openItemId]
    )

    useEffect(() => {
        const items = document.querySelectorAll(ACCORDION_ITEM_SELECTOR)

        items.forEach((item, idx) => {
            const itemId = `${identifier}-item-${idx}`
            const iconId = 'accordion-icon'
            const isItemOpen = openItemId === itemId

            item.setAttribute('id', itemId)

            const title = item.querySelector(`${ACCORDION_ITEM_TITLE_SELECTOR}`)

            const iconElement = document.createElement('div')
            iconElement.setAttribute('id', iconId)
            iconElement.innerHTML = isItemOpen ? minus : plus

            title?.querySelector(`#${iconId}`)?.remove()
            title?.append(iconElement)

            title?.addEventListener('click', () =>
                onAccordionTitleClick(itemId)
            )

            const content = item.querySelector<HTMLElement>(
                `${ACCORDION_ITEM_CONTENT_SELECTOR}`
            )
            const contentMaxHeight = isItemOpen
                ? `${content?.scrollHeight}px`
                : '0px'

            if (content) {
                content.style.maxHeight = contentMaxHeight
                content.classList.toggle('active', isItemOpen)
            }
        })

        return () => {
            const titles = document.querySelectorAll(
                ACCORDION_ITEM_TITLE_SELECTOR
            )
            titles.forEach((title) =>
                title.removeEventListener('click', onAccordionTitleClick)
            )
        }
    }, [onAccordionTitleClick, isValidating, identifier, openItemId])
}

export default useAccordion
